<template>
  <Card :bordered="true" class="customflow-container" dis-hover>
    <p slot="title">
      <slot name="title" v-if="userInfo.gradeId !== -2"></slot>
      <span v-else>{{ $t('home.data_center') }}</span>
    </p>
    <!-- <a href="#" slot="extra">
      <slot name="extra"></slot>
    </a> -->
    <div class="data-center-body">
      <!--高管显示内容-->
      <div v-if="userInfo.gradeId === -4" class="group-data">
        <Row class-name="row-box">
          <Col span="12" class="col-left">
            <div class="charts-body">
              <echart :options="doubleLineOptions"></echart>
            </div>
          </Col>
          <Col span="12" class="col-right">
            <div class="group-sales-data">
              <div class="group-data-item">
                <div>
                  <div class="top-title">{{ $t('home.month_sales') }}</div>
                  <div>
                    <span class="top-number-one">￥</span>
                    <span class="top-number-two">{{
                      formatSales(groupData.saleAmount)
                    }}</span>
                    <!-- <span class="top-number-three">万</span> -->
                    <span
                      class="group-rate"
                      :class="{
                        'increase-data': groupData.increaseRate > 0,
                        'decrease-data': groupData.increaseRate <= 0,
                      }"
                    >
                      <span
                        v-if="groupData.increaseRate <= 0"
                        class="decrease-icon"
                      ></span>
                      <span v-else class="increase-icon"></span>
                      <span class="rate-number">{{
                        groupData.increaseRate | toPositive
                      }}</span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="group-data-item">
                <div>
                  <div class="top-title">{{ $t('home.monthplan_sales') }}</div>
                  <div>
                    <span class="top-number-one">￥</span>
                    <span class="top-number-four">{{
                      formatSales(groupData.goalAmount)
                    }}</span>
                    <!-- <span class="top-number-three">万</span> -->
                  </div>
                </div>
                <div class="right-item">
                  <div class="top-title">{{ $t('home.achieving_rate') }}</div>
                  <div class="top-number-five">
                    {{ groupData.rate | toPositive }}
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <!--督导显示内容-->
      <div v-else-if="userInfo.gradeId === -3" class="area-data">
        <Row class-name="row-box">
          <Col span="12" class="col-left">
            <div class="chart-topdata">
              <div class="">
                <span>{{ $t('home.week_sales') }}</span>
              </div>
              <div>
                <span class="data-number">{{
                  formatSales(areaData.count)
                }}</span>
                <span
                  class="area-rate"
                  :class="{
                    'increase-data': areaData.increaseRate > 0,
                    'decrease-data': areaData.increaseRate <= 0,
                  }"
                >
                  <span
                    v-if="areaData.increaseRate <= 0"
                    class="decrease-icon"
                  ></span>
                  <span v-else class="increase-icon"></span>
                  <span class="rate-number">{{
                    areaData.increaseRate | toPositive
                  }}</span>
                </span>
              </div>
            </div>
            <div class="area-chart charts-body">
              <echart :options="lineOptions"></echart>
            </div>
          </Col>
          <Col span="12" class="col-right">
            <div class="area-sales-data">
              <div class="area-data-item">
                <div class="area-sales-head">{{ $t('home.week_top3') }}</div>
              </div>
              <div class="area-data-item">
                <ul>
                  <li
                    v-for="(item, index) in areaData.rank"
                    :key="index"
                    class="range-item"
                  >
                    <span class="range-number">{{
                      (index + 1) | formatRange
                    }}</span>
                    <span class="range-depname">{{ item.depName }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <!--店长,店员显示内容-->
      <div v-else class="dep-data">
        <!--销售额-->
        <Row class="row-box">
          <Col span="24" class-name="col-box">
            <div class="col-left">
              <div>
                <div class="sales-word">{{ dataName[1] }}</div>
                <div class="data-number">{{ formatSales(dataNumber[1]) }}</div>
              </div>
            </div>
            <span
              class="col-right"
              :class="{
                'increase-data': dataRate[1] > 0,
                'decrease-data': dataRate[1] <= 0,
              }"
            >
              <span
                v-if="dataRate[1] <= 0"
                class="decrease-icon smaller-icon"
              ></span>
              <span v-else class="increase-icon smaller-icon"></span>
              <span class="rate-number">{{ dataRate[1] | toPositive }}</span>
            </span>
          </Col>
        </Row>
        <div class="top-symbol">≈</div>
        <Row type="flex" justify="space-between" class-name="row-box">
          <!--订单数-->
          <Col span="10" class-name="col-box">
            <div class="col-left">
              <div>
                <div class="data-name">{{ dataName[5] }}</div>
                <div class="data-number">{{ formatSales(dataNumber[5]) }}</div>
              </div>
            </div>
            <span
              class="col-right"
              :class="{
                'increase-data': dataRate[5] > 0,
                'decrease-data': dataRate[5] <= 0,
              }"
            >
              <span
                v-if="dataRate[5] <= 0"
                class="decrease-icon smaller-icon"
              ></span>
              <span v-else class="increase-icon smaller-icon"></span>
              <span class="rate-number">{{ dataRate[5] | toPositive }}</span>
            </span>
          </Col>
          <span class="mid-symbol">≈</span>
          <!--客单价-->
          <Col span="10" class-name="col-box">
            <div class="col-left">
              <div>
                <div>{{ dataName[4] }}</div>
                <div class="data-number">{{ formatSales(dataNumber[4]) }}</div>
              </div>
              <span
                class="col-right"
                :class="{
                  'increase-data': dataRate[4] > 0,
                  'decrease-data': dataRate[4] <= 0,
                }"
              >
                <span
                  v-if="dataRate[4] <= 0"
                  class="decrease-icon smaller-icon"
                ></span>
                <span v-else class="increase-icon smaller-icon"></span>
                <span class="rate-number">{{ dataRate[4] | toPositive }}</span>
              </span>
            </div>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          <Col span="10" class-name="bottom-symbol">≈</Col>
          <Col span="10" class-name="bottom-symbol">≈</Col>
        </Row>
        <Row type="flex" justify="space-between" class-name="row-box">
          <!--客流-->
          <Col span="5" class-name="col-box">
            <div class="col-left bottom-left">
              <div>
                <div class="data-name">{{ dataName[0] }}</div>
                <div class="data-number">{{ formatSales(dataNumber[0]) }}</div>
              </div>
            </div>
            <span
              class="col-right bottom-rate"
              :class="{
                'increase-data': dataRate[0] > 0,
                'decrease-data': dataRate[0] <= 0,
              }"
            >
              <span
                v-if="dataRate[0] <= 0"
                class="decrease-icon smaller-icon"
              ></span>
              <span v-else class="increase-icon smaller-icon"></span>
              <span
                class="rate-number overflow-number"
                :title="dataRate[0] | toPositive"
                >{{ dataRate[0] | toPositive }}</span
              >
            </span>
          </Col>
          <span class="mid-symbol">×</span>
          <!--成交率-->
          <Col span="5" class-name="col-box">
            <div class="col-left bottom-left">
              <div>
                <div class="data-name">{{ dataName[2] }}</div>
                <div class="data-number">{{ dataNumber[2] }}%</div>
              </div>
            </div>
            <span
              class="col-right bottom-rate"
              :class="{
                'increase-data': dataRate[2] > 0,
                'decrease-data': dataRate[2] <= 0,
              }"
            >
              <span
                v-if="dataRate[2] <= 0"
                class="decrease-icon smaller-icon"
              ></span>
              <span v-else class="increase-icon smaller-icon"></span>
              <span
                class="rate-number overflow-number"
                :title="dataRate[2] | toPositive"
                >{{ dataRate[2] | toPositive }}</span
              >
            </span>
          </Col>
          <!--件单价-->
          <Col span="5" class-name="col-box">
            <div class="col-left bottom-left">
              <div>
                <div class="data-name">{{ dataName[6] }}</div>
                <div class="data-number">{{ dataNumber[6] }}</div>
              </div>
            </div>
            <span
              class="col-right bottom-rate"
              :class="{
                'increase-data': dataRate[6] > 0,
                'decrease-data': dataRate[6] <= 0,
              }"
            >
              <span
                v-if="dataRate[6] <= 0"
                class="decrease-icon smaller-icon"
              ></span>
              <span v-else class="increase-icon smaller-icon"></span>
              <span
                class="rate-number overflow-number"
                :title="dataRate[6] | toPositive"
                >{{ dataRate[6] | toPositive }}</span
              >
            </span>
          </Col>
          <span class="mid-symbol">×</span>
          <!--连带率-->
          <Col span="5" class-name="col-box">
            <div class="col-left bottom-left">
              <div>
                <div class="data-name">{{ dataName[3] }}</div>
                <div class="data-number">{{ dataNumber[3] }}%</div>
              </div>
            </div>
            <span
              class="col-right bottom-rate"
              :class="{
                'increase-data': dataRate[3] > 0,
                'decrease-data': dataRate[3] <= 0,
              }"
            >
              <span
                v-if="dataRate[3] <= 0"
                class="decrease-icon smaller-icon"
              ></span>
              <span v-else class="increase-icon smaller-icon"></span>
              <span
                class="rate-number overflow-number"
                :title="dataRate[3] | toPositive"
                >{{ dataRate[3] | toPositive }}</span
              >
            </span>
          </Col>
        </Row>
      </div>
    </div>
  </Card>
</template>

<script>
import echart from '../../../components/echart.vue';
import api from '../../../api/home';
import { doubleLineOption } from '../../../config/echarts';
import { lineOption } from '../../../config/echarts';
import { getLanguage } from 'wdz-common-components/src/common/js/ovoSystem';
export default {
  name: 'data-center-card',
  components: { echart },
  data() {
    return {
      depData: [],
      areaData: [],
      groupData: [],
      dataName: [
        this.$t('home.customflow'),
        this.$t('home.saledata') + '（￥）',
        this.$t('home.turnover_rate'),
        this.$t('home.joint_rate'),
        this.$t('home.customer_price') + '（￥）',
        this.$t('home.order_number'),
        this.$t('home.unit_price'),
      ], //'客流','销售额(￥)','成交率','连带率','客单价（￥）','件单价','订单数'
      dataNumber: [],
      dataRate: [],
      doubleLineOptions: {},
      lineOptions: {},
      doubleLineLegend: [
        this.$t('home.sales_goal'),
        this.$t('home.sales_real'),
      ],
      lineLegend: [this.$t('home.week_sales')],
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    servers() {
      return this.$system.$state.servers;
    },
    userInfo() {
      return this.$system.$state.userInfo;
    },
  },
  methods: {
    getData() {
      if (this.userInfo.gradeId === -2) {
        this.getDepData();
      } else if (this.userInfo.gradeId === -3) {
        this.getAreaData();
      } else if (this.userInfo.gradeId === -4) {
        this.getGroupData();
      }
    },
    //店长数据
    getDepData() {
      api
        .getDataForDep({})
        .then(res => {
          this.depData = res.data || [];
          //排序后可以通过下标判断对应为哪条数据,1客流，2销售额，3成交率，4连带率，5客单价，7件单价，6订单数
          this.depData.sort(function (a, b) {
            return a.dimension - b.dimension;
          });
          this.depData.forEach(item => {
            this.dataNumber.push(item.currentData);
            this.dataRate.push(item.rate);
          });
        })
        .catch(error => {
          this.$Message.error(
            `${this.$t('home.error_getdatacenter')}：${error}`
          );
        });
    },
    //督导数据
    getAreaData() {
      api.getDataForArea({}).then(res => {
        this.areaData = res.data;
        this.formatAreaChartData(res.data);
      });
    },
    //高管数据
    getGroupData() {
      api.getDataForGroup({}).then(res => {
        this.groupData = res.data;
        this.groupData.rate = (this.groupData.rate * 100).toFixed(2);
        this.formatGroupChartData(res.data);
      });
    },
    formatGroupChartData(data) {
      let option = doubleLineOption;
      let seriesData1 = [],
        seriesData2 = [];
      option.legend.data = this.doubleLineLegend;
      option.series[0].name = this.doubleLineLegend[0];
      option.series[1].name = this.doubleLineLegend[1];
      data.list.forEach(item => {
        seriesData1.push(item.goalAmount);
        seriesData2.push(item.salesAmount);
      });
      option.series[0].data = seriesData1;
      option.series[1].data = seriesData2;
      this.doubleLineOptions = doubleLineOption;
    },
    formatAreaChartData(data) {
      let option = lineOption;
      let seriesData = [];
      data.list.forEach(item => {
        seriesData.push({ name: item.date, value: item.count });
      });
      option.series[0].data = seriesData;
      this.lineOptions = option;
    },
    formatSales(value) {
      // 143323 => 14.3万
      if (value) {
        var num = Number(value);
        const lang = getLanguage();
        if (lang == 'zh-CN' || lang === 'zh-TW') {
          if (num > 10000) {
            return (num / 10000).toFixed(1) + this.$t('home.ten_thousand');
          } else {
            return num;
          }
        } else {
          if (num > 1000) {
            return (num / 1000).toFixed(1) + this.$t('home.ten_thousand');
          } else {
            return num;
          }
        }
      } else {
        return 0;
      }
    },
  },
  filters: {
    toPositive(value) {
      if (value) {
        // -1 => 1
        return Math.abs(value) + '%';
      } else {
        return 0 + '%';
      }
    },
    formatRange(value) {
      //1 => 01
      if (value) {
        return value < 10 ? '0' + value : value;
      } else {
        return 0;
      }
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
.dep-data {
  width: 100%;
  margin-top: -7px;
  .row-box {
    height: 50px;
    .col-box {
      position: relative;
      height: 100%;
      border: 1px solid #ebebeb;
      .col-left {
        float: left;
        display: flex;
        height: 100%;
        width: 90px;
        margin-left: 15px;
        align-items: center;
        flex-flow: wrap;
        div {
          text-align: center;
        }
      }
      .bottom-left {
        margin-left: 5px;
        .data-number {
          font-size: 14px;
        }
      }
      .col-right {
        position: absolute;
        display: inline-block;
        bottom: 0px;
        right: 15px;
        width: 90px;
        text-align: right;
        .smaller-icon {
          width: 13px;
          height: 13px;
        }
      }
      .bottom-rate {
        right: 0;
        width: 70px;
        .rate-number {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 13px;
          color: #7f7f7f;
        }
      }
    }
  }

  .top-symbol {
    text-align: center;
    font-size: 14px;
  }
  .mid-symbol {
    line-height: 60px;
  }
  .bottom-symbol {
    text-align: center;
  }
}
.group-data {
  width: 100%;
  height: 100%;
  .row-box {
    height: 100%;
    .col-left {
      height: 100%;
      // border-right: 2px solid #ddd;
    }
    .col-right {
      height: 100%;
      // padding: 40px;
      .group-sales-data {
        height: 100%;
        padding-top: 50px;
        .group-data-item {
          display: flex;
          padding: 0 20px;
          height: 33%;
          align-items: center;
          flex-flow: wrap;
          .group-rate {
            margin-left: 13px;
          }
          .top-title {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 15px;
            color: #999999;
            letter-spacing: 0;
          }
          .right-item {
            margin-left: 18px;
          }
          &:last-of-type {
            margin-top: 30px;
          }
        }
        .top-number-one {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 13px;
          color: #999999;
          text-align: center;
        }
        .top-number-two {
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          font-size: 24px;
          color: #ff9900;
          margin: 0 3px;
        }
        .top-number-three {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 13px;
          color: #999999;
          text-align: center;
        }
        .top-number-four {
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          font-size: 24px;
          color: #999999;
          margin: 0 3px;
        }
        .top-number-five {
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          font-size: 24px;
          color: #999999;
          margin: 0 3px;
        }
      }
    }
  }
}
.area-data {
  width: 100%;
  height: 100%;
  .row-box {
    height: 100%;
    .col-left {
      height: 100%;
      border-right: 2px solid #ddd;
      .chart-topdata {
        height: 40%;
        padding: 0 40px;
        div {
          display: flex;
          align-items: center;
          height: 50%;
        }
        .area-rate {
          margin-left: 20px;
        }
      }
      .area-chart {
        height: 60%;
      }
    }
    .col-right {
      height: 100%;
      padding: 0 20px;
      .area-sales-head {
        margin-top: 10px;
      }
      .range-item {
        margin: 15px 0;
        color: #000;
        .range-number {
          display: inline-block;
          width: 20px;
          height: 20px;
          margin-right: 10px;
          line-height: 20px;
          text-align: center;
          background: #e6e6e6;
          border-radius: 2px;
          color: #f90;
        }
      }
    }
  }
}
.data-center-body {
  height: 100%;
  .charts-body {
    @include wh100;
  }
}
.data-number {
  color: #000;
  font-size: 18px;
}
.rate-number {
  font-size: 16px;
  vertical-align: middle;
}
.overflow-number {
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  vertical-align: middle;
  text-align: left;
}
.increase-data {
  // color: red;
}
.decrease-data {
  // color: #1d8e2d;
}
.increase-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  vertical-align: middle;
  background: url('../../../../public/images/home/home_icon_up.png') no-repeat
    center/cover;
}
.decrease-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  vertical-align: middle;
  background: url('../../../../public/images/home/home_icon_down.png') no-repeat
    center/cover;
}
@media screen and (min-width: 300px) and (max-width: 600px) {
  .dep-data .row-box {
    height: 80px;
  }
}
</style>
